import WithRender from "../../templates/layouts/layoutUploadMyAccount.html";

export default WithRender({});
